import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Parser from 'rss-parser';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import { isAuthenticated } from '../../auth/Auth';
import { getGroups, getGroupDetail } from '../../actions/Groups';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import PostsTableGroup from '../organisms/PostsTableGroup';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  rowTitle: {
    // marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  titlePage: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: '15px 15px 0'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroups,
          getGroupDetail,
          getShops,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('rssItems', 'setRssItems', []),
  withState('rssItemsFull', 'setRssItemsFull', []),
  withState('openDetailPost', 'setDetailPost', false),
  withState('content', 'setContent', ''),
  withState('openTable', 'updateOpenTable', false),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = props.rowsPerPage;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const size = parseInt(limit || limitNum, 10);
      const start = parseInt((page - 1) * size, 10);
      const rssItemsFullArray = props.rssItemsFull;
      console.log('rssItemsFullArray', rssItemsFullArray);
      const items = rssItemsFullArray.slice(start, parseInt(start + size, 10));
      props.updateOpenTable(true);
      props.setRssItems(items);

      console.log('start, size, items', start, size, items);
      props.setPage(page);
      props.setRowsPerPage(limit || limitNum);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      const parser = new Parser();
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/42755547-51ae-4b47-af16-f50b58d106f2.rss`,
        (err, feed) => {
          if (err) throw err;
          const size = this.props.rowsPerPage;
          const start = (this.props.page - 1) * size;
          this.props.setRssItemsFull(feed.items);
          const rssItemsFullArray = feed.items;
          const items = rssItemsFullArray.slice(
            parseInt(start, 10),
            parseInt(size, 10)
          );
          this.props.updateOpenTable(true);
          this.props.setRssItems(items);
        }
      );
    }
  })
);

const NotificationsGroup = enhance(
  ({
    classes,
    rssItems,
    openTable,
    handleChangePage,
    page,
    rowsPerPage,
    setRowsPerPage,
    handleChangeRowsPerPage,
    rssItemsFull
  }) => {
    console.log(rssItems);

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="運営からのお知らせ" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            運営からのお知らせ
          </Typography>
          {openTable && (
            <>
              <ExPaginationGroup
                count={
                  rssItemsFull.length % rowsPerPage > 0
                    ? Math.floor(rssItemsFull.length / rowsPerPage) + 1
                    : Math.floor(rssItemsFull.length / rowsPerPage)
                }
                selectedPage={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                limit={rowsPerPage}
                totalCount={rssItems.length}
                setLimit={setRowsPerPage}
                hideRowsPerPage
              />
              <PostsTableGroup rssItems={rssItems} />

              <ExPaginationGroup
                count={
                  rssItemsFull.length % rowsPerPage > 0
                    ? Math.floor(rssItemsFull.length / rowsPerPage) + 1
                    : Math.floor(rssItemsFull.length / rowsPerPage)
                }
                selectedPage={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                limit={rowsPerPage}
                totalCount={rssItems.length}
                setLimit={setRowsPerPage}
                hideRowsPerPage
              />
            </>
          )}
        </main>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(NotificationsGroup));
